module.exports = __webpack_public_path__ + "static/media/3.3f0fc4c3.jpg";